"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.techCodeDescriptions = void 0;
exports.techCodeDescriptions = {
    "C56.3": {
        codeType: "ICD",
        code: "C56.3",
        description: "Malignant neoplasm of bilateral ovaries",
        shortDescription: "Malignant neoplasm of bilateral ovaries",
        tenantDefined: true
    },
    "31000099-2007257": {
        codeType: "TECH",
        code: "31000099",
        description: "FLOW CYTOMETRY CELL SURF MARKER TECHL ONLY 1ST",
        shortDescription: "FLOWCYTOMETRY/ TC 1 MARKER",
        tenantDefined: true,
        costCenter: "2007257",
        procCode: "88184",
        codeEffectiveDate: "1/1/21",
        allowProfessional: "1",
        requireFeeOverride: "0"
    },
    "88173": {
        codeType: "CPT",
        code: "88173",
        description: "CYTP EVAL FINE NEEDLE ASPIRATE INTERP & REPORT",
        shortDescription: "CYTOPATH EVAL FNA REPORT",
        tenantDefined: true
    },
    "88172": {
        codeType: "CPT",
        code: "88172",
        description: "CYTP FINE NDL ASPIRATE IMMT CYTOHIST STD DX 1ST",
        shortDescription: "CYTP DX EVAL FNA 1ST EA SITE",
        tenantDefined: true
    },
    "L02.91": {
        codeType: "ICD",
        code: "L02.91",
        description: "Cutaneous abscess, unspecified",
        shortDescription: "Cutaneous abscess, unspecified",
        tenantDefined: true
    },
    "88305": {
        codeType: "CPT",
        code: "88305",
        description: "LEVEL IV SURG PATHOLOGY GROSS&MICROSCOPIC EXAM",
        shortDescription: "TISSUE EXAM BY PATHOLOGIST",
        tenantDefined: true
    },
    "31000099-2007254": {
        codeType: "TECH",
        code: "31000099",
        description: "FLOW CYTOMETRY CELL SURF MARKER TECHL ONLY 1ST",
        shortDescription: "FLOWCYTOMETRY/ TC 1 MARKER",
        tenantDefined: true,
        costCenter: "2007254",
        procCode: "88184",
        codeEffectiveDate: "1/1/21",
        allowProfessional: "1",
        requireFeeOverride: "0"
    },
    "E04.1": {
        codeType: "ICD",
        code: "E04.1",
        description: "Nontoxic single thyroid nodule",
        shortDescription: "Nontoxic single thyroid nodule",
        tenantDefined: true
    }
};
//# sourceMappingURL=tech-code-descriptions.js.map